import React from "react"

const OmOss = () => (
    <section className="om-oss">
        <div className="container padding-top padding-bottom">
            <h2>
                Om oss
            </h2>
            <p>
                Siden starten i 2017 har vi henta opp meir enn 100 tonn marin forsøpling. Vi har en høy aktivitet og et stort engasjement, og har klart å bli en tydelig formidler av holdningsskapende arbeid. Havet kjenner ingen grenser, så vi setter inn vår innsats der det kan gjøre en forskjell, men hovedsaklig så har vi aktivitet på de 4 øyene som utgjør Giske kommune samt nabokommunene. Grunnskolen er vår beste samarbeidspartner, og elever og foreldre rydder på fritiden og skaffer midler til skoleturer. Vi har også et nært samarbeid med Mental Helse, og hevder å rydde litt i fjøra gjør godt for både kropp og sjel. 
            </p>
        </div>
    </section>
)

export default OmOss